import { gql } from "@apollo/client";

export const GET_RELATION_CHANGE_LOGS = gql`
    query GetRelationChangeLogs(
        $page: Int!
        $size: Int!
        $filters: RelationChangeLogFiltersTypeInput
    ) {
        getRelationChangeLogs(page: $page, size: $size, filters: $filters) {
            content {
                id
                entityType
                entityId
                entityName
                relationType
                operationType
                operatorId
                operatorRole
                dataType
                oldData
                newData
                note
                createdAt
                createdBy
            }
            totalElements
            totalPages
            currentPage
            size
            hasNext
            hasPrevious
        }
    }
`;

export interface RelationChangeLogFiltersType {
    entityType?: string;
    entityId?: string;
    relationType?: string;
    operatorId?: number;
    startTime?: number;
    endTime?: number;
}

export interface RelationChangeLogType {
    id: number;
    entityType: string;
    entityId: string;
    entityName?: string;
    relationType: string;
    operationType: number;
    operatorId?: number;
    operatorRole?: string;
    dataType: number;
    oldData?: string;
    newData?: string;
    note?: string;
    createdAt: number;
    createdBy?: number;
}

export interface RelationChangeLogPageType {
    content: RelationChangeLogType[];
    totalElements: number;
    totalPages: number;
    currentPage: number;
    size: number;
    hasNext: boolean;
    hasPrevious: boolean;
}

export interface GetRelationChangeLogsData {
    getRelationChangeLogs: RelationChangeLogPageType;
}

export interface GetRelationChangeLogsVariables {
    page: number;
    size: number;
    filters?: RelationChangeLogFiltersType;
}